import $ from 'jquery';

class HeaderNavigation {
  constructor() {
    this.SUB_NAVIGATION_ANIMATE_MS = 150;
    this.SUB_NAVIGATION_OPEN_CLASS = 'is-open';

    this.$headerNavBtns = $('.c-header-nav__item');

    this.addEvent();
  }

  addEvent() {
    this.$headerNavBtns.each((i, el) => this.setSubNavigationEvent($(el)));
  }

  setSubNavigationEvent($headerNavBtn) {
    const $subNavigation = $headerNavBtn.find('.js-header-nav-sub');
    let isOpen = false;

    $subNavigation.css({ display: 'none' });

    $headerNavBtn.on({
      'mouseenter' : () => {
        if (isOpen) {
          return;
        }

        isOpen = true;
        this.showSubNavigation($subNavigation);
      },
      'mouseleave' : () => {
        if (!isOpen) {
          return;
        }

        isOpen = false;
        this.hideSubNavigation($subNavigation);
      },
    })
  }

  showSubNavigation($subNavigation) {
    $subNavigation.addClass(this.SUB_NAVIGATION_OPEN_CLASS);
    this.isOpen = true;

    $subNavigation.stop(false, false).fadeIn(this.SUB_NAVIGATION_ANIMATE_MS);
  }

  hideSubNavigation($subNavigation) {
    $subNavigation.stop(false, false).fadeOut(this.SUB_NAVIGATION_ANIMATE_MS, () => {
      $subNavigation.removeClass(this.SUB_NAVIGATION_OPEN_CLASS);
    });
  }
}

export default HeaderNavigation;
